import { jsx as o } from "react/jsx-runtime";
import { keyframes as t, usePrefersReducedMotion as s, Box as e } from "@chakra-ui/react";
const a = t`
    from {
        opacity: 0%;
        transform: translate(0, -5px)
    }

    to {
        opacity: unset;
        transform: none;
    }
`, f = ({ children: r }) => {
  const n = s();
  return /* @__PURE__ */ o(e, { overflow: "hidden", children: /* @__PURE__ */ o(e, { animation: n ? void 0 : `${a} 0.2s ease-in`, children: r }) });
};
export {
  f as TableExpand
};
